import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import { StyledSelect } from 'lib/styles';

const Container = styled.div`
	padding: 40px 0 0;
`;

const Label = styled.p`
	font-size: 12px;
	color: #9B9B9B;
	margin: 0 0 8px;
`;

const Size = props => {
	const { t } = props;
	return (
		<Container>
			<Label>{t('controls/image/size/label')}</Label>
			<StyledSelect
				id="size-select"
				style={{ width: '100%' }}
				options={[
					{ value: 'cover', name: t('controls/image/size/cover') },
					{ value: 'contain', name: t('controls/image/size/contain') },
				]}
				value={props.size}
				onChange={event => props.changesHandler({ size: event.target.value })}
			/>
		</Container>
	)
}

Size.propTypes = {
	t: PropTypes.func,
	size: PropTypes.oneOf(['cover', 'contain']),
	changesHandler: PropTypes.func,
}

export default translate('translations')(Size)
